import React from 'react'
import {Flex, Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {remCalc} from '../../../theme/_utils'
import {FormattedMessage} from 'react-intl'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import ProductTileImage from '../../product-tile/partials/product-tile-image'

const RecipeUtilityTile = ({styles, tile}) => {
    const navigate = useNavigation()

    const handleNavigateToPdp = () => {
        navigate(tile?.c_slugUrl)
    }

    return (
        <Flex
            maxW={{base: '100%', lg: remCalc(168)}}
            maxH={{base: 'unset', lg: remCalc(380)}}
            data-testid="made-with-tile-testid"
            {...styles.tile}
            marginBottom={{base: 'xsmall.base', md: 'xsmall.lg'}}
            alignItems="center"
        >
            <Flex {...styles.tile?.imagecontainer} width={remCalc(168)} height={remCalc(168)}>
                <ProductTileImage
                    product={tile}
                    // productUrl={productUrl}
                    variant="freeItemPromo"
                    isInformativeLabelActive={false}
                />
            </Flex>
            <Flex {...styles.tile?.imagecontainer}></Flex>
            <Flex gap="xsmall.base" flexDir="column" minH={remCalc(60)}>
                <Text
                    textStyle="head-xxsmall"
                    overflow="hidden"
                    display="-webkit-box"
                    sx={{
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                    textOverflow="ellipsis"
                    fontWeight="medium"
                    textAlign="center"
                    minH={remCalc(40)}
                >
                    {tile?.c_defaultName}
                </Text>
                <Text
                    textStyle="body-xsmall"
                    fontWeight="normal"
                    color="text.secondary"
                    textAlign="center"
                >
                    <Text>{tile?.name}</Text>
                </Text>
            </Flex>
            <Flex maxW={remCalc(122)} justifyContent="center" alignSelf="center">
                <Button
                    onClick={handleNavigateToPdp}
                    variant="primary"
                    textStyle="body-xsmall"
                    fontWeight="medium"
                    paddingY={remCalc(12)}
                    paddingX="small.base"
                >
                    <FormattedMessage
                        id="recipes.details_page.carousel.discover_more"
                        defaultMessage="Discover More"
                    />
                </Button>
            </Flex>
        </Flex>
    )
}

RecipeUtilityTile.propTypes = {
    tile: PropTypes.shape({
        c_defaultName: PropTypes.string,
        name: PropTypes.string,
        shortDescription: PropTypes.string,
        uid: PropTypes.string,
        image: PropTypes.string,
        imageGroups: PropTypes.array,
        c_slugUrl: PropTypes.string,
        c_localizedPowerImages: PropTypes.any,
        c_subModelIdentifier: PropTypes.string,
    }),
    styles: PropTypes.shape(),
}

export default RecipeUtilityTile
